import React, { useState, useEffect } from 'react';


import './cb.css';


const DEFAULT_CONFIG_DATA = {
    "OLLAMA_URL": "http://127.0.0.1:11434",
    "EMBED_MODEL": "nomic-embed-text",
    "GEN_MODEL": "llama3:8b",
    "CHUNK_SIZE": 800,
    "CHUNK_OVERLAP": 200,
    "DOCS_DIR": "DOCS",
    "CHROMA_DB_DIR": "DB",
    "PROMPT_CFG": "Tu sei un assistente online virtuale. Usa il contesto di seguito indicato per dare la risposta alle domande.Se il contesto non contiene la risposta comunica che non puoi rispondere."
};

/**
 * Componente form per la visualizzazione e la modifica dei parametri RAG.
 * * @param {object} props
 * @param {object} props.initialConfig - La configurazione corrente da modificare.
 * @param {function} props.onSave - Funzione chiamata al salvataggio (passa la nuova config).
 * @param {function} props.onCancel - Funzione chiamata all'annullamento.
 */
const ConfigForm = ({ initialConfig = DEFAULT_CONFIG_DATA, onSave, onCancel, configName = "Configurazione Attuale" }) => {
    // Clona la configurazione iniziale per usarla come stato locale
    const [formData, setFormData] = useState(initialConfig);

    useEffect(() => {
        // Aggiorna lo stato del form se la configurazione iniziale esterna cambia
        setFormData(initialConfig);
    }, [initialConfig]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        
        // Gestione dei numeri interi
        if (['CHUNK_SIZE', 'CHUNK_OVERLAP'].includes(name)) {
            // Converte in numero intero solo se è una stringa valida, altrimenti lascia la stringa vuota
            setFormData({
                ...formData,
                [name]: value === "" ? "" : parseInt(value, 10) || 0
            });
        } else {
            setFormData({
                ...formData,
                [name]: value
            });
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Qui si può aggiungere una logica di validazione
        
        // Passa i dati salvati (convertendo le stringhe numeriche a int prima di salvare)
        const finalData = {
            ...formData,
            CHUNK_SIZE: parseInt(formData.CHUNK_SIZE, 10),
            CHUNK_OVERLAP: parseInt(formData.CHUNK_OVERLAP, 10),
        };

        if (onSave) {
            // Esegue la funzione di callback passata dalla prop
            onSave(finalData);
        }
    };

    return (
        <div className="config-form-container">
            <h2>Modifica Configurazione RAG: {configName}</h2>
            <form onSubmit={handleSubmit}>
                
                {/* GRIGLIA PARAMETRI DI RETE E MODELLO */}
                <div className="form-grid">
                    
                    {/* OLLAMA_URL */}
                    <div className="form-group">
                        <label htmlFor="OLLAMA_URL">OLLAMA URL (Endpoint)</label>
                        <input
                            type="text"
                            id="OLLAMA_URL"
                            name="OLLAMA_URL"
                            value={formData.OLLAMA_URL}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    
                    {/* EMBED_MODEL */}
                    <div className="form-group">
                        <label htmlFor="EMBED_MODEL">EMBEDDING Model</label>
                        <input
                            type="text"
                            id="EMBED_MODEL"
                            name="EMBED_MODEL"
                            value={formData.EMBED_MODEL}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    
                    {/* GEN_MODEL */}
                    <div className="form-group">
                        <label htmlFor="GEN_MODEL">Generation Model</label>
                        <input
                            type="text"
                            id="GEN_MODEL"
                            name="GEN_MODEL"
                            value={formData.GEN_MODEL}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    
                    {/* CHUNK_SIZE */}
                    <div className="form-group">
                        <label htmlFor="CHUNK_SIZE">Chunk Size (Token/Caratteri)</label>
                        <input
                            type="number"
                            id="CHUNK_SIZE"
                            name="CHUNK_SIZE"
                            value={formData.CHUNK_SIZE}
                            onChange={handleChange}
                            required
                            min="100"
                        />
                    </div>
                    
                    {/* CHUNK_OVERLAP */}
                    <div className="form-group">
                        <label htmlFor="CHUNK_OVERLAP">Chunk Overlap</label>
                        <input
                            type="number"
                            id="CHUNK_OVERLAP"
                            name="CHUNK_OVERLAP"
                            value={formData.CHUNK_OVERLAP}
                            onChange={handleChange}
                            required
                            min="0"
                        />
                    </div>

                    {/* DOCS_DIR */}
                    <div className="form-group">
                        <label htmlFor="DOCS_DIR">Directory Documenti (Docs Dir)</label>
                        <input
                            type="text"
                            id="DOCS_DIR"
                            name="DOCS_DIR"
                            value={formData.DOCS_DIR}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    {/* CHROMA_DB_DIR */}
                    <div className="form-group">
                        <label htmlFor="CHROMA_DB_DIR">Directory DB (Chroma DB Dir)</label>
                        <input
                            type="text"
                            id="CHROMA_DB_DIR"
                            name="CHROMA_DB_DIR"
                            value={formData.CHROMA_DB_DIR}
                            onChange={handleChange}
                            required
                        />
                    </div>

                </div>
                
                {/* PROMPT_CFG (Campo a larghezza intera) */}
                <div className="form-group full-width">
                    <label htmlFor="PROMPT_CFG">Prompt di Sistema (Istruzioni IA)</label>
                    <textarea
                        id="PROMPT_CFG"
                        name="PROMPT_CFG"
                        value={formData.PROMPT_CFG}
                        onChange={handleChange}
                        required
                    />
                </div>

                {/* AZIONI */}
                <div className="form-actions">
                    <button type="button" className="cancel-button" onClick={onCancel}>
                        Annulla
                    </button>
                    <button type="submit" className="save-button">
                        💾 Salva Configurazione
                    </button>
                </div>
            </form>
        </div>
    );
};

export default ConfigForm;